<claas-header [(isMenuOpen)]="expanded" [showMenuIconButton]="false" [title]="'Remote Display View'">
  <!--<ng-container ngProjectAs="content-right">
    @if ((isLoggedIn$ | async) === false) {
      <claas-button
        [id]="'btn-signin-dealer'"
        [buttonClass]="buttonClass.SECONDARY_OUTLINE"
        size="medium"
        [isLoading]="false"
        [disabled]="false"
        [stretch]="false"
        [tooltip]="'Sign in as dealer (Okta)'"
        (click)="signInAsDealer()"
      >Sign in as dealer</claas-button>
      <claas-button
        [id]="'btn-signin-customer'"
        [buttonClass]="buttonClass.PRIMARY"
        size="medium"
        [isLoading]="false"
        [disabled]="false"
        [stretch]="false"
        [tooltip]="'Sign in as customer (Auth0)'"
        (click)="signInAsCustomer()"
      >Sign in as customer</claas-button>
    }
  </ng-container>-->
</claas-header>
<div class="app-container">
  <router-outlet></router-outlet>
</div>
